// web → seller 리다이렉트 시 /login URL query로 전달되는 값
export interface SnsCallbackParams {
  redirect?: string;
  loginType?: string;
  accessToken?: string;
  textId?: string | null;
}

/**
 * /login 페이지 진입 시 URL query에서 SNS 콜백 파라미터를 읽음.
 * web이 네이버 토큰 교환 후 `${returnOrigin}/login?loginType=...&accessToken=...` 형태로 보낸 값.
 */
export function readSnsCallbackParams(): SnsCallbackParams | null {
  const search = window.location.search;
  if (!search) return null;
  const urlParams = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  const loginType = urlParams.get("loginType");
  const accessToken = urlParams.get("accessToken");
  if (!loginType || !accessToken) return null;
  return {
    redirect: urlParams.get("redirect") || "",
    loginType,
    accessToken,
  };
}
